var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6C15.8954 6 15 6.89543 15 8V10H4C2.89543 10 2 10.8954 2 12V30C2 31.1046 2.89543 32 4 32H36C37.1046 32 38 31.1046 38 30V16.0324C38.0007 16.0112 38.0007 15.9899 38 15.9686V12C38 10.8954 37.1046 10 36 10H25V8C25 6.89543 24.1046 6 23 6H17ZM16 20.7542L4 17.3257V30H36V17.3258L24 20.7544V21C24 22.1046 23.1046 23 22 23H18C16.8954 23 16 22.1046 16 21V20.7542ZM16.0252 18.6814L4 15.2456V12H36V15.2458L23.9748 18.6816C23.8223 17.7283 22.9962 17 22 17H18C17.0039 17 16.1778 17.7283 16.0252 18.6814ZM18 20.0315C18.0007 20.0101 18.0007 19.9888 18 19.9675V19H22V21H18V20.0315ZM23 10V8H17V10H23Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.de81528dffa4780b55aa11e8cbde3c28.svg";
export { ForwardRef as ReactComponent };